export default "__VITE_ASSET__b26d3d02__"